import { Box, Container, Stack, Typography, Button, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export function CtaBanner() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      navigate(`/signup?email=${encodeURIComponent(email.trim())}`);
    } else {
      navigate('/signup');
    }
  };

  return (
    <Box sx={{ py: 14, position: 'relative', overflow: 'hidden' }}>
      {/* Space background */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url(https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3?w=1920&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.15,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `
            radial-gradient(ellipse at 30% 50%, rgba(26,76,216,0.3) 0%, transparent 50%),
            radial-gradient(ellipse at 70% 50%, rgba(201,177,7,0.15) 0%, transparent 50%)
          `,
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: 32, md: 48 },
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: '#f0f0f5',
            mb: 2,
          }}
        >
          Ready to Modernize Your HR?
        </Typography>
        <Typography variant="h6" sx={{ color: '#a0a5b5', mb: 4, fontWeight: 400 }}>
          Join 1,200+ South African companies already using Rosta.
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center" sx={{ mb: 3 }}>
            <TextField
              placeholder="you@company.co.za"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                flex: 1,
                maxWidth: 320,
                '& .MuiOutlinedInput-root': {
                  borderRadius: '9999px',
                  backgroundColor: 'rgba(18, 18, 31, 0.8)',
                  color: '#f0f0f5',
                  '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
                  '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
                  '&.Mui-focused fieldset': { borderColor: '#3d7aff' },
                },
                '& .MuiInputBase-input::placeholder': { color: '#6b7280', opacity: 1 },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                background: 'linear-gradient(135deg, #1a4cd8, #3d7aff)',
                borderRadius: '9999px',
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontSize: 16,
                fontWeight: 600,
                '&:hover': { background: 'linear-gradient(135deg, #3d7aff, #1a4cd8)' },
              }}
            >
              Get Started →
            </Button>
          </Stack>
        </Box>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
          {['Free for up to 10 employees', 'No credit card required'].map((text) => (
            <Stack key={text} direction="row" spacing={0.5} alignItems="center">
              <Box sx={{ color: '#22c55e', fontSize: 14, fontWeight: 700 }}>✓</Box>
              <Typography variant="body2" sx={{ color: '#a0a5b5', fontSize: 14 }}>{text}</Typography>
            </Stack>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
